import {
  Component,
  OnInit,
  OnDestroy,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
} from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/operator/takeUntil';
import { TranslateService } from '@ngx-translate/core';

import { SkillAvailableCurator, SkillSpecializationCreateRequest } from '../../../models/skill-learning.model';
import { SkillSpecializationFacadeService } from '../../../services/skill-specialization-facade.service';
import { SkillRoleService } from '../../../services/skill-role.service';
import { ToastService } from '../../../../../../services/toast.service';
import { SidebarService } from '../../../../../../services/side-bar.service';
import { SpecializationFormValue } from '../specialization-form/specialization-form.component';

const PLACEHOLDER_SPECIALIZATION_ID = 'new';
const ROUTE_SPECIALIZATIONS = '/dashboard/specializations';

@Component({
  selector: 'app-create-specialization-container',
  templateUrl: './create-specialization-container.component.html',
  styleUrls: ['./create-specialization-container.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CreateSpecializationContainerComponent implements OnInit, OnDestroy {

  availableCurators: SkillAvailableCurator[] = [];
  isSubmitting: boolean = false;

  private destroy$ = new Subject<void>();

  constructor(
    private facade: SkillSpecializationFacadeService,
    private roleService: SkillRoleService,
    private toastService: ToastService,
    private sidebarService: SidebarService,
    private router: Router,
    private cdr: ChangeDetectorRef,
    private translate: TranslateService,
  ) {}

  get requireCuratorForCurrentUser(): boolean {
    return this.roleService.canCreateSpecialization();
  }

  ngOnInit(): void {
    this.sidebarService.setSelectedMenuOption('spec-list');
    this.loadAvailableCurators();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onFormSubmitted(value: SpecializationFormValue): void {
    this.isSubmitting = true;
    const request: SkillSpecializationCreateRequest = {
      name: value.name,
      description: value.description,
    };
    this.facade.createSpecialization(request, value.curatorIds)
      .takeUntil(this.destroy$)
      .subscribe(
        () => this.handleCreateSuccess(),
        () => this.handleCreateError(),
      );
  }

  onCancelRequested(): void {
    this.router.navigate([ROUTE_SPECIALIZATIONS]);
  }

  private loadAvailableCurators(): void {
    this.facade.fetchAvailableCurators(PLACEHOLDER_SPECIALIZATION_ID)
      .takeUntil(this.destroy$)
      .subscribe(
        curators => this.handleCuratorsLoaded(curators),
        () => this.cdr.markForCheck(),
      );
  }

  private handleCuratorsLoaded(curators: SkillAvailableCurator[]): void {
    this.availableCurators = curators;
    this.cdr.markForCheck();
  }

  private handleCreateSuccess(): void {
    this.isSubmitting = false;
    this.toastService.success(this.translate.instant('SKILL_LEARNING_ADMIN_CREATE_SUCCESS'));
    this.router.navigate([ROUTE_SPECIALIZATIONS]);
  }

  private handleCreateError(): void {
    this.isSubmitting = false;
    this.toastService.error(this.translate.instant('SKILL_LEARNING_ADMIN_CREATE_ERROR'));
    this.cdr.markForCheck();
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/common/skill-learning/components/admin/create-specialization-container/create-specialization-container.component.ts